// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const es = {
  app: 'Aplicación',
  messages: {
    'default': {
      title: 'Algo salió mal…',
      body: 'Ocurrió un error inesperado',
      button: 'Entendido',
    },
    '00001': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00002': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00003': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00004': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00005': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00006': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00007': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00008': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00009': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00010': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00011': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00012': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00013': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00014': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00015': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00016': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00017': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00018': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00019': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00020': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00021': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00022': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00023': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00024': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00025': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00026': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00027': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00028': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00029': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00030': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00031': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00032': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00033': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00034': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00035': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00036': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00037': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00038': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00039': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00040': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00041': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00042': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00043': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00044': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00045': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00046': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00047': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00048': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00049': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00050': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00051': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00052': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00053': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00054': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00055': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00056': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00057': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00058': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00059': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00060': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00061': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00062': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00063': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00064': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00065': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00066': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00067': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00068': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00069': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00070': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00071': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00072': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00073': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00074': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00075': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00076': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00077': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00078': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00079': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00080': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00081': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00082': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00083': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00084': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00085': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00086': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00087': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00088': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00089': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00090': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00091': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00092': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00093': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00094': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00095': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00096': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00097': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00098': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00099': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00100': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00101': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00102': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00103': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00104': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00105': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00106': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00107': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00108': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00109': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00110': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00111': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00112': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00113': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00114': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00115': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00116': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00117': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00118': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00119': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00120': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00121': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00122': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00123': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00124': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00125': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00126': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00127': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00128': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00129': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00130': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00131': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00132': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00133': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00134': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00135': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00136': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00137': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00138': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00139': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00140': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00141': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00142': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00143': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00144': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00145': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00146': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00147': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00148': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00149': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00150': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00151': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00152': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00153': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00154': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00155': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00156': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00157': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00158': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00159': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00160': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00161': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    '00162': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00163': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00164': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00165': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00166': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00167': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00168': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00169': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo con nuevamente.',
      button: 'Entendido',
    },
    '00170': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente',
      button: 'Entendido',
    },
    '00171': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente',
      button: 'Entendido',
    },
    '00172': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamente',
      button: 'Entendido',
    },
    '00173': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo con nuevamente.',
      button: 'Entendido',
    },
    '00174': {
      title: 'Algo salió mal...',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00175': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo con nuevamente.',
      button: 'Entendido',
    },
    '00176': {
      title: 'Algo salió mal...',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '000176': {
      title: 'Algo salió mal...',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00177': {
      title: 'Algo salió mal...',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00178': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo con nuevamente.',
      button: 'Entendido',
    },
    '00179': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo con nuevamente.',
      button: 'Entendido',
    },
    '00180': {
      title: 'Algo salió mal…',
      body: 'La cuenta no tiene fondos suficientes.',
      button: 'Ok',
    },
    '00181': {
      title: 'Algo salió mal…',
      body: 'Pago pendiente.',
      button: 'Ok',
    },
    '00182': {
      title: 'Algo salió mal…',
      body: 'Se superó el número de reintentos de pago, intente realizar otra compra o contáctenos.',
      button: 'Ok',
    },
    '00183': {
      title: 'Algo salió mal…',
      body: 'Bin no encontrado.',
      button: 'Ok',
    },
    '00200': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00201': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00202': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00203': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00204': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00205': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00206': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00207': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00208': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00209': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00210': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00211': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00212': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00213': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00214': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00215': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00216': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00217': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00218': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00219': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00220': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00221': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00222': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00223': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00224': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00225': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00226': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00227': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00228': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00229': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00230': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00300': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00301': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00302': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00303': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00304': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00305': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00306': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00307': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00308': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00309': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00310': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00311': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00312': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00313': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00314': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00315': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00316': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00317': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00318': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00319': {
      title: 'Algo salió mal…',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    '00333': {
      title: 'Estos boletos volaron!',
      body: 'Lo sentimos, los boletos han sido comprados por alguien más. Intenta con otra zona y no te pierdas del evento.',
      button: 'Entendido',
    },
    '00334': {
      title: '¡Estos boletos volaron!',
      body: 'Lo sentimos, los boletos han sido comprados por alguien más. Intenta con otra zona y no te pierdas del evento.',
      button: 'Entendido',
    },
    '00335': {
      title: '¡Estos boletos volaron!',
      body: 'Lo sentimos, los boletos han sido comprados por alguien más. Intenta con otra zona y no te pierdas del evento.',
      button: 'Entendido',
    },
    '00336': {
      title: '¡Estos boletos volaron!',
      body: 'Lo sentimos, los boletos han sido comprados por alguien más. Intenta con otra zona y no te pierdas del evento.',
      button: 'Entendido',
    },
    '00337': {
      title: '¡Estos boletos volaron!',
      body: 'Lo sentimos, los boletos han sido comprados por alguien más. Intenta con otra zona y no te pierdas del evento.',
      button: 'Entendido',
    },
    '00338': {
      title: '¡Ups!',
      body: 'Lo sentimos, ya no quedan boletos disponibles en la zona seleccionada.',
      button: 'Entendido',
    },
    '00400': 'Objeto no recibido para realizar la acción',
    '00401': 'Código de usuario no válido',
    '00402': 'Usuario no encontrado',
    '00403': 'Datos incompletos para realizar un token de actualización',
    '00404': 'Error de proceso de caché',
    '00405': 'Error al leer el cuerpo',
    '00406': 'Error de proceso marshal',
    '00407': 'Error de proceso unmarshal',
    '00408': 'Error de validación',
    '00409': 'Este nombre de usuario ya existe',
    '00410': 'Este correo electrónico o número de teléfono ya existe',
    '00411': 'El código de verificación no se entrega correctamente',
    '00412':
      'El código proporcionado no coincide con lo que esperaba el servidor',
    '00413': 'Dos o más modificaciones están ocurriendo simultáneamente',
    '00414': 'El proveedor ya es compatible',
    '00415':
      'Hay una discrepancia de código y el servicio no puede configurar el token de software TOTP autenticación multifactor (MFA)',
    '00416': 'El código ha caducado',
    '00417': 'El grupo ya existe',
    '00418': 'Error interno',
    '00419': 'No tiene permitido usar su identidad de correo electrónico',
    '00420': 'Respuesta Lambda inválida',
    '00421': 'El flujo de OAuth especificado no es válido',
    '00422': 'Parámetro invalido',
    '00423': 'Contraseña invalida',
    '00424':
      'El rol proporcionado para la configuración de SMS no tiene permiso para publicar mediante Amazon SNS',
    '00425':
      'La relación de confianza no es válida para el rol proporcionado para la configuración de SMS',
    '00426': 'La configuración del grupo de usuarios no es válida',
    '00427':
      'Un usuario excede el límite para un recurso de Amazon Web Services solicitado',
    '00428': 'No puedo encontrar un método de autenticación multifactor (MFA)',
    '00429': 'El usuario no está autorizado',
    '00430': 'Se requiere un restablecimiento de contraseña',
    '00431': 'No se cumple la condición previa',
    '00432': 'No puedo encontrar el recurso solicitado',
    '00433': 'El alcance especificado no existe',
    '00434':
      'La autenticación multifactor (MFA) de contraseña de un solo uso basada en el tiempo (TOTP) del token de software no está activada para el grupo de usuarios',
    '00435':
      'El usuario ha realizado demasiados intentos fallidos para una acción determinada',
    '00436':
      'El usuario ha realizado demasiadas solicitudes para una determinada operación',
    '00437': 'La solicitud no está autorizada',
    '00438': 'Excepción inesperada con Lambda',
    '00439': 'El identificador especificado no es compatible',
    '00440':
      'Intenta realizar una operación que no está habilitada para el cliente del grupo de usuarios',
    '00441': 'Token no admitido se pasa a una operación',
    '00442': 'El usuario está en un estado no admitido',
    '00443':
      'Está intentando modificar un grupo de usuarios mientras hay un trabajo de importación de usuarios en curso para ese grupo',
    '00444': 'Excepción de validación de usuario con el servicio Lambda',
    '00445': 'La usuario no se confirma con éxito',
    '00446': 'El usuario no se encuentra',
    '00447': 'Los complementos del grupo de usuarios no están habilitados',
    '00448':
      'La etiqueta del grupo de usuarios no se puede configurar ni actualizar',
    '00449':
      'Ha superado el número de intentos de inicio de sesión, vuelva en 15 minutos.',
    '00450':
      'Error de rol de usuario, solo el vendedor puede realizar esta acción',
    '00500': 'Error interno, por favor intenta más tarde ',
    '00501': 'Error interno, por favor intenta más tarde ',
    '00502': 'Error interno, por favor intenta más tarde ',
    '00503': 'Error interno, por favor intenta más tarde ',
    '00504': 'Error interno, por favor intenta más tarde ',
    '00505': 'Error interno, por favor intenta más tarde ',
    '00506': 'Error interno, por favor intenta más tarde ',
    '00507': 'Error interno, por favor intenta más tarde ',
    '00600': 'Error interno, por favor intenta más tarde ',
    '00601': 'Error interno, por favor intenta más tarde ',
    '00602': 'Error interno en el recaptcha, por favor intenta más tarde ',
    '00603': 'Error interno en el recaptcha, por favor intenta más tarde ',
    '00604': 'Error interno en el recaptcha, por favor intenta más tarde ',
    '00605': 'Error interno en el recaptcha, por favor intenta más tarde ',
    '00606': 'Error interno en el recaptcha, por favor intenta más tarde ',
    '00607': 'Error interno en el recaptcha, por favor intenta más tarde ',
    '00608': 'Error interno en el recaptcha, por favor intenta más tarde ',
    '00609': 'Usted es considerado un bot, por favor intenta más tarde',
    'BAYONET_FRAUD_PROCESSED': {
      title: 'Tu pago no se puede realizar',
      body: 'Comunícate con tu banco o prueba con otro método de pago para intentarlo nuevamnete.',
      button: 'Entendido',
    },
    'UNAUTHORIZED': {
      title: 'Algo salió mal...',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    'READ_RESPONSE_ERROR': {
      title: 'Algo salió mal...',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    'REQUEST_ERROR': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    'FORBIDDEN_ERROR': {
      title: 'Algo salió mal...',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    'CONFLICT_ERROR': {
      title: 'Algo salió mal...',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    'PRECONDITION_REQUIRED_ERROR': {
      title: '😱 Error al procesar tu pago',
      body: 'Te recomendamos: Revisar la información ingresada, comunicarte con tu banco o probar con otro método de pago para intentarlo nuevamente.',
      button: 'Entendido',
    },
    'PAYMENT_FAILED': {
      title: 'Algo salió mal...',
      body: 'Lo sentimos, en este momento no podemos procesar tu pago, inténtalo nuevamente. Si el error persiste mándanos un mail a: servicio@boletia.com',
      button: 'Entendido',
    },
    'REQUIRED': {
      title: 'Revisa el número de tu tarjeta',
      body: 'Asegúrate de haber escrito todos los dígitos correctamente, sin espacios ni errores. ',
      button: 'Entendido',
    },
    'INVALID_FORMAT': {
      title: 'Revisa el número de tu tarjeta',
      body: 'Asegúrate de haber escrito todos los dígitos correctamente, sin espacios ni errores. ',
      button: 'Entendido',
    },
    'INVALID_LENGTH': {
      title: 'Revisa los dígitos de tu tarjeta y el código de seguridad',
      body: 'Verifica que el número de tu tarjeta y el código de seguridad tengan la cantidad dígitos correcta.',
      button: 'Entendido',
    },
    'EXPIRED': {
      title: 'Tu tarjeta ya venció',
      body: 'Usa una tarjeta con vigencia actual para completar tu compra',
      button: 'Entendido',
    },
    'MIN_LENGTH': {
      title: 'Revisa el número de tu tarjeta',
      body: 'Asegúrate de haber escrito todos los dígitos correctamente, sin espacios ni errores. ',
      button: 'Entendido',
    },
    'MAX_LENGTH': {
      title: 'Revisa el número de tu tarjeta',
      body: 'Asegúrate de haber escrito todos los dígitos correctamente, sin espacios ni errores. ',
      button: 'Entendido',
    },
    'INVALID': {
      title: 'Revisa el número de tu tarjeta',
      body: 'Asegúrate de haber escrito todos los dígitos correctamente, sin espacios ni errores. ',
      button: 'Entendido',
    },
    "Mont can't be blank": {
      title: 'Revisa la fecha de vigencia de tu tarejeta',
      body: 'Verifica que el mes y año estén completos, usando el formato MM/AA.',
      button: 'Entendido',
    },
    'Mont is invalid': {
      title: 'Revisa la fecha de vigencia de tu tarejeta',
      body: 'Verifica que el mes y año estén completos, usando el formato MM/AA.',
      button: 'Entendido',
    },
    'Year is invalid': {
      title: 'Revisa la fecha de vigencia de tu tarejeta',
      body: 'Verifica que el mes y año estén completos, usando el formato MM/AA.',
      button: 'Entendido',
    },
  },

  billboards: {
    eventTags: {
      today: '¡Es Hoy!',
      next: 'Próximamente',
      new: '¡Nuevo!',
      lastDay: 'Último día',
      notMiss: '¡No te lo pierdas!',
      promo: '¡Promoción!',
      soldOut: 'Agotado',
    },
  },
  checkout: {
    paths: {
      home: 'Boletos',
      auth: 'Registro',
      customization: 'Personalización',
      payment: 'Pago',
      success: '¡Ya tienes tus boletos!',
      addons: 'Protección',
      thanks: 'Gracias',
    },
    thanks: {
      title: '¡Gracias!',
      message: 'Gracias por tu visita.',
    },
    forms: {
      validations: {
        max: '{{label}} debe tener máximo {{max}} caracteres',
        min: '{{label}} debe tener al menos {{min}} caracteres',
        required: '{{label}} es obligatorio',
        email: 'Ingresa un correo electrónico válido',
        isRequired: 'Este campo es obligatorio',
      },
      fields: {
        name: 'Nombre',
        holder: 'Titular',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        password: 'Contraseña',
        lastName: 'Apellido',
        creditCard: 'Tarjeta',
        validity: 'Vigencia',
        validityDate: 'Vigencia (MM/AA)',
        zipCode: 'Código postal',
        country: 'País',
        state: 'Estado',
        city: 'Ciudad',
        coupon: 'Cupón',
        date: 'Fecha',
        birthDate: 'Fecha de nacimiento',
      },
      buttons: {
        next: 'Siguiente',
      },
    },
    buttons: {
      continue: 'Continuar',
      registAndParticipate: 'Registrarme y participar',
      continuePurchase: 'Continuar comprando',
      searchAnotherArea: 'Buscar en otra zona',
      clearTickets: 'Limpiar boletos',
      orderByPrice: 'Ordenar por precio',
      confirm: 'Confirmar',
      save: 'Guardar',
      change: 'Cambiar',
      activeCoupon: 'Activar cupón',
      apply: 'Aplicar',
      retry: 'Reintentar',
      searchOtherZone: 'Buscar en otra zona',
      clearTickets: 'Limpiar boletos',
      login: 'Iniciar sesión',
      loginSeller: 'Iniciar sesión como vendedor',
      buyTickets_one: 'Comprar {{count}} boleto',
      buyTickets_other: 'Comprar {{count}} boletos',
      getTickets_one: 'Obtener {{count}} boleto',
      getTickets_other: 'Obtener {{count}} boletos',
    },
    global: {
      aboutEvent: 'Acerca del evento',
      about: 'Acerca de',
      more: 'Conoce más',
      subtotal: 'Subtotal',
      noPromo: 'Sin descuento',
      charge: 'Cargos por servicio',
      paymentMethodCharge: 'Método de pago',
      ticketFee: 'Costo por boleto emitido',
      paymentProcessor: 'Procesador de pago',
      ReviewPurchase: 'Resumen de orden',
      place: 'El lugar',
      sponsors: 'Patrocinadores',
      ContactOrganizer: 'Contacta al organizador',
      readMore: 'Ver más',
      readLess: 'Ver menos',
      viewLocation: 'Ver ubicación',
      eventOnline: 'Evento en linea',
      addCalendar: 'Agregar a calendario',
      moreEventInfo: '+ Más información del evento',
      acceptLabel: 'Aceptar',
      cancelLabel: 'Cancelar',
      here: 'aquí',
      search: 'Buscar...',
      category: 'Categoría',
      city: 'Ciudad',
      seeAll: 'Ver todo',
      from: 'Desde',
      buy: 'Comprar',
      buyTickets: 'Comprar boletos',
      getTickets: 'Obtener boletos',
      price: 'Precio',
      filters: 'Filtros',
      filterEvents: 'Filtrar Eventos',
      clearFilters: 'Limpiar filtros',
      applyFilters: 'Aplicar filtros',
      up: 'Volver arriba',
      dates: 'Fechas',
      start: 'Inicia',
      end: 'Termina',
      row: 'Fila',
      seat: 'Asiento',
      ticket: 'Boleto',
      yourTickets: 'Tus boletos',
      total: 'Total',
      terms: 'Términos y Condiciones',
      termsPurchase: 'Términos de compra',
      privacyNotice: 'Aviso de Privacidad',
      needHelp: '¿Necesitas ayuda?',
      remainingTime: 'Tiempo restante',
      ticketsFly: 'Los boletos están volando',
      madeIn:
        'Hecho en México con 🔥 por Boletia S.A de C.v. Derechos Reservados {{year}}',
      noAvailability_one:
        'No hay {{count}} asiento disponible en esta zona, puedes reintentar con menos boletos o regresa y busca en una zona diferente.',
      noAvailability_other:
        'No hay {{count}} asientos disponibles en esta zona, puedes reintentar con menos boletos o regresa y busca en una zona diferente.',
      checkoutEnd: 'Tu proceso de compra ha finalizado',
      noTickets: 'No has seleccionado tus boletos',
      pleaseSelectTickets:
        'Por favor, selecciona tu boletos y continua con el proceso de compra',
      checkOtherEvents: 'Consulta otros eventos en boletia.com',
      differentEvent: 'Este evento es diferente al original',
      noSendCode: 'No has enviado ningún código',
      yourTickets2: '¡Tus boletos!',
      reserveYourSpot: '¡Reserva tu lugar ahora!',
      addYourTickets: 'Agrega tus boletos para el evento.',
      noDate: 'Sin fecha',
      rangeTimeOneDay: 'de {{startTime}} a {{endTime}}',
      rangeTime: 'de {{startTime}} al {{endTime}}',
    },
    modals: {
      onDeleteTicket: {
        title: '¿Deseas eliminar los asientos pre-seleccionados?',
        text: 'Así podrás elegir nuevos asientos.',
        acceptLabel: 'Eliminar selección',
      },
      onBackModal: {
        title: '¿Estás seguro de que quieres volver?',
        text: 'Si regresas ahora, los boletos que seleccionaste se liberarán y tendrás que buscarlos nuevamente',
        acceptLabel: 'Seguir comprando',
        cancelLabel: 'Salir de la compra',
      },
      onHoldTokenExpired: {
        title: 'Tiempo expirado',
        text: 'Lo sentimos, el tiempo de tu compra se ha terminado.',
        acceptLabel: 'Aceptar',
      },
      onMaxTickets: {
        title: 'Limite superado',
        text: 'Lo sentimos, solo puedes seleccionar {{max}} boletos como máximo.',
        acceptLabel: 'Aceptar',
      },
      checkAvailability: {
        title: '¡Últimos boletos disponibles!',
        text: `Esta zona cuenta con solo {{availability}} boletos disponibles. Puedes continuar con la compra de estos últimos lugares, o escoger otros boletos.`,
        acceptLabel: 'Continuar compra',
        cancelLabel: 'Escoger otros boletos',
      },
      checkAvailabilityRSVP: {
        title: '¡Últimos boletos disponibles!',
        text: 'Esta zona cuenta con solo {{availability}} boletos disponibles. Puedes continuar con la compra de estos últimos lugares, o escoger otros boletos.',
        acceptLabel: 'Continuar compra',
        cancelLabel: 'Escoger otros boletos',
      },
      checkMinPerSale: {
        title: 'Compra mínima',
        text: `Debes comprar al menos {{minPerSel}} boletos en esta zona. ¿Deseas continuar la compra con {{minPerSel}} boletos?`,
        acceptLabel: 'Continuar compra',
        cancelLabel: 'Escoger otros boletos',
      },
      clearSelection: {
        title: 'Eliminar selección',
        text: `Al eliminar tus boletos se quitarán de tu selección y podrás seleccionar unos nuevamente`,
        acceptLabel: 'Eliminar selección',
      },
      onBestAvailableFail: {
        message:
          'Los boletos han sido comprados por alguien más. Intenta con otra zona y no te pierdas del evento',
        title: '¡Estos boletos volaron!',
        label: 'Ver otras zonas',
      },
      onSaveTicketsFail: {
        message:
          'Parece que algunos de los boletos que seleccionaste no se agregaron. Por favor, vuelve a elegirlos para continuar con tu compra.',
        title: 'No pudimos asegurar tus boletos',
        label: 'Volver a seleccionar',
      },
      setBookingMode: {
        title: 'Aviso',
        text: 'Ya tienes boletos seleccionados, si cambias de vista perderás tus boletos. ¿Deseas continuar?',
        cancelLabel: 'Cancelar',
        acceptLabel: 'Aceptar',
      },
      timeExpired: {
        title: 'Tiempo expirado',
        text: 'Lo sentimos, el tiempo de tu compra se ha terminado.',
        acceptLabel: 'Aceptar',
      },
      bookingExpired: {
        title: 'Estos boletos volaron',
        text: 'Lo sentimos, el tiempo de tu compra se terminó.',
        acceptLabel: 'Aceptar',
      },
      onBackButtonEvent: {
        title: 'Aviso',
        text: 'Ya tienes boletos seleccionados, si cambias de vista perderás tus boletos. ¿Deseas continuar?',
        cancelLabel: 'Cancelar',
        acceptLabel: 'Aceptar',
      },
      BOOKING_EXPIRED: {
        title: 'Estos boletos volaron',
        text: 'Lo sentimos, el tiempo de tu compra se terminó.',
        acceptLabel: 'Aceptar',
      },
      LINK_NOT_AVAILABLE: {
        title: 'Enlace no disponible',
        text: 'Este enlace fue desactivado o eliminado y no puede usarse. Para más información, contacta al organizador',
        acceptLabel: 'Entendido',
      },
      INVALID_SESSION_TOKEN: {
        title: 'Sesión Expirada',
        text: 'Tu sesión ha expirado. Por favor, actualiza la página para continuar con tu compra.',
        acceptLabel: 'Actualizar Página',
      },
      LINK_INACTIVE: {
        title: 'Enlace inactivo',
        text: 'Este enlace fue desactivado y no puede usarse. Para más información, contacta al organizador',
        acceptLabel: 'Entendido',
      },
      LINK_USED: {
        title: 'Lo sentimos, este enlace ya fue usado',
        text: 'Tu pago no fue procesado porque este enlace ya se utilizó y no puede volver a usarse. Para más información, contacta al organizador.',
        acceptLabel: 'Entendido',
      },
      LINK_EXPIRED: {
        title: 'Enlace expirado',
        text: 'Este enlace ya expiró y no puede usarse. Para más información, contacta al organizador',
        acceptLabel: 'Entendido',
      },
    },
    loadings: {
      bestAvailable: 'Seleccionando los mejores asientos',
      releasingTickets: 'Liberando tus boletos',
      loadingTickets: 'Preparando tus boletos...',
      almostAlready: '¡Ya casi están listos tus boletos!',
      creatingOxxo: 'Creando código OXXO…',
      pleaseWait: 'Espere un momento por favor...',
      loadingBillboard: 'Cargando cartelera...',
      inProgress: 'En proceso',
      dontCloseWindow:
        'No cierres ni actualices esta ventana hasta que confirmemos tu pago.',
      processingPayment: 'Procesando tu pago...',
    },
    home: {
      map: {
        instruction: 'Interactúa desde mapa para ver más boletos.',
      },
      alerts: {
        noTickets: 'No hay boletos disponibles',
        noTicketsMsg:
          'El evento no ha iniciado la venta o los boletos se encuentran agotados',
        expired: 'Colorín colorado, este evento ha terminado',
        expiredMsg: 'Te invitamos a buscar grandes evento en',
        linkExpired: 'Enlace Expirado',
        linkExpiredMsg:
          'Este enlace expiró. Ya no hay boletos disponibles; contacta al organizador del evento.',
        linkUsed: 'Enlace ya utilizado',
        linkUsedMsg:
          'Este enlace ya se utilizó y no puede volver a usarse. Para más información, contacta al organizador.',
        linkInactive: 'Enlace desactivado',
        linkInactiveMsg:
          'Este enlace fue desactivado y no puede usarse. Para más información, contacta al organizador',
        inactive: 'Pronto podrás acceder al evento',
        inactiveMsg: 'Y así obtener tus boletos y vivir la mejor experiencia.',
        minTickets_one:
          'Debes seleccionar al menos {{count}} boleto de {{name}}',
        minTickets_other:
          'Debes seleccionar al menos {{count}} boletos de {{name}}',
        maxTickets_one:
          'Puedes seleccionar máximo {{count}} boleto de {{name}}',
        maxTickets_other:
          'Puedes seleccionar máximo {{count}} boletos de {{name}}',
        sorryNoTickets: 'Lo sentimos, no hay suficientes boletos para {{name}}',
        recaptchaError: 'Error al generar recaptcha token',
        soldOut: 'Boletos agotados',
        soldOutMsg: `Las entradas para este evento están agotadas, permanece atento a nuevas disponibilidades.`,
      },
      fan: {
        title: 'Venta a fans',
        label: 'Ingresa tu contraseña de fan',
      },
      cart: {
        title: 'Te pueden gustar',
        desc: 'Explora más opciones en el mapa',
        selectFromMap: 'Selecciona tus asientos desde el mapa.',
        instruction:
          'Si deseas agregar más boletos puedes agregarlos desde el mapa.',
        seatSelected: 'Fila {{parent}} | Asiento {{own}} ',
        seatQuantity: '{{own}} x{{quantity}}',
        ticketsQuantity: 'No. Boletos {{quantity}}',
        quantityTickets_one: '{{count}} Boleto',
        quantityTickets_other: '{{count}} Boletos',
        ticketsAvailability: '{{availability}} lugares disponibles',
        price: 'Precio: ',
        plusCharge: '+ cargos',
        zone: 'Zona {{zone}}: {{zoneCount}}/{{max}}',
        soldByZone: 'Vendidos por zona: {{availability}}',
        selectZone: 'Selecciona la zona',
        selectZoneDesc: 'Elige que tan cerca estarás del escenario',
      },
      saturated: {
        changeOver:
          'Tu oportunidad de buscar otros boletos se acabó, pero aún tienes estos boletos apartados.',
        retry:
          'Al regresar perderás los boletos apartados en esta zona. Aún tienes',
        retry2_one: ' {{count}} intento ',
        retry2_other: ' {{count}} intentos ',
        retry3: 'pero por la alta demanda puede que ya no existan más boletos.',
        timeOut: 'Tu sesión está',
        timeOut2: ' apunto de caducar. ',
        timeOut3:
          'En caso de no continuar con la compra, la sesión expirará y perderás tu lugar en el proceso de compra.',
        timer: 'Tienes',
        timer2_one: ' {{count}} intento ',
        timer2_other: ' {{count}} intentos ',
        timer3: 'para explorar zonas y asientos disponibles',
        alert: 'Tiempo expirado',
        alertText: 'Lo sentimos, el tiempo de tu compra se ha terminado.',
      },
    },
    billboards: {
      noEvents: 'No hay eventos.',
      noEvents2:
        'Se están haciendo pruebas de sonido, así que mantente al pendiente o busca más eventos ',
      searchByDate: 'Buscar por fecha',
      allDates: 'Todas las fechas',
      availableDate: 'Fecha disponible',
      filterBillboard: 'Filtrar en cartelera',
      loadingEvents: 'Cargando eventos...',
      moreEvents: 'Mostrar más eventos',
      TicketsFrom: 'Boletos desde',
    },
    auth: {
      title: 'Agrega tus datos de contacto',
      subtitle: 'Tus boletos serán enviados al',
      subtitleWallet: 'Tus boletos estarán disponibles en la',
      sendBy: 'correo electrónico',
      sendByWallet: 'app Boletia.',
      registered: 'registrado.',
      formData: 'Datos de envío del boleto',
      phoneData: 'Número de verificación',
      formDataWallet: 'Datos de confirmación de compra',
      phoneDataWallet: 'Número de acceso a la app y a tus boletos',
      verifyPhone: 'Enviaremos un código para verificar tú número',
      sendWhatsApp: 'Enviar código por WhatsApp',
      validateSms: 'Validar por SMS',
      validateWhatsApp: 'Validar por WhatsApp',
      validOTP: 'Código validado correctamente',
      invalidOTP: 'Código inválido, inténtalo de nuevo',
      otpExpired: 'Tu código ya expiró. Pide uno nuevo.',
      checkData: 'Verifica tus datos',
      verifyPhone: 'Verifica tu número',
      preRegister: 'Ingresa tu código',
      enterOTP:
        'Ingresa el código de 6 dígitos que enviamos a tu celular. {{phone}}',
      preRegisterOTP:
        'Te enviamos un código de 6 dígitos a tu celular {{phone}}',
      verifyText:
        'Asegúrate de que tu número sea correcto para recibir el código',
      termsAndConditions1: 'Al Continuar con la compra, aceptas los',
      termsAndConditions2: 'Términos de compra',
      termsAndConditions3: 'y nuestro',
      termsAndConditions4: 'Aviso de privacidad',
      termsAndConditionsMobile1: 'Al Continuar con la compra, aceptas los',
      termsAndConditionsMobile2: 'y',
      preRegisterTermsAndConditions1:
        'Al continuar con el registro, aceptas los',
      preRegisterTermsAndConditions2: 'Términos y condiciones',
      preRegisterTermsAndConditions3: 'y el ',
      preRegisterTermsAndConditions5: 'de esta promoción.*',
      wallet: 'Accede a tus boletos desde la app usando tu celular',
      hiUser: '¡Hola {{name}}!',
      youAreLogged: 'iniciaste sesión como vendedor de este evento.',
      alreadyAccount: '¿Eres vendedor?',
      signIn: 'Inicia sesión',
      signInSeller: 'Inicia sesión como vendedor',
      logInToTickets:
        'Si fuiste asignado a este evento como vendedor, inicia sesión aquí.',
      SignAsGuest: 'Ingresa como invitado',
      loginSeller: 'Iniciaste sesión con tu cuenta ',
      loginSeller2: ' como vendedor de este evento. ',
      loginUser: 'Iniciaste sesión con ',
      loginUser2:
        ', enviaremos tus boletos a tu email, una vez que termines tu proceso de compra. ',
      forgotPassword: '¿Olvidaste tu contraseña?',
      resendCodeIn: 'Reenvíalo en',
      seconds: 'segundos',
      NotReceive: '¿No lo recibiste?',
      resendSMS: 'Reenviar por SMS',
      resendWhatsApp: 'Reenviar por WhatsApp',
      edit: 'Editar Datos',
      loginErrorTitle: 'Error al iniciar sesión',
      loginErrorPhone:
        'Su usuario no cuenta con un número telefónico asociado y es requerido para continuar con el proceso de compra, por favor registre un número telefónico válido en el portal de administración dentro del apartado de Perfil',
      loginErrorAuth:
        'Su usuario no cuenta con autorización para vender en este evento.',
    },
    customization: {
      useThisName: 'Usar el mismo nombre para todos los boletos',
      weWantKnowYouBetter: 'Queremos conocerte mejor',
      helpUsQuestions:
        'Ayúdanos a mejorar la experiencia respondiendo unas preguntas',
      namesAssistants: 'Nombre de los asistentes',
      customAssistant:
        'Recibirás los boletos personalizados con los nombres de cada asistente',
      noCustom: 'No personalizar',
      getTickets: 'Obtener boletos',
      ifCustom:
        'Si deseas, puedes personalizar cada boleto con el nombre de los asistentes.',
      customTickets: 'Personalizar boletos',
      nameIt: 'Ponle nombre',
      enterTheName: 'Ingresa el nombre que se verá en tu boleto: {{ticket}}',
      ticketOf: 'Boleto de {{name}}',
      ticketNumber: 'Boleto {{number}}',
      saveNames: 'Guardar Nombres',
      emailAlreadyUsed:
        'Este correo ya está registrado para otro boleto. Usa uno diferente.',
    },
    survey: {
      title: 'Registro del asistente',
      subtitle: 'Completa los datos del asistente',
      save: 'Guardar',
      noQuestions: 'No hay preguntas configuradas para este evento.',
      footer: { poweredBy: 'Powered by Boletia' },
      errors: {
        loadError: 'Error al cargar los datos de la encuesta',
        saveError: 'Error al guardar los datos',
      },
    },
    payment: {
      oxxo: 'oxxo',
      cash: 'Efectivo',
      paymentMethod: 'Forma de pago',
      customerInfo: 'Información del cliente',
      YouOneStepAway: '¡Estás a un paso!',
      justMakePayment: '¡Ya casi son tuyos, solo haz el pago!',
      enterPaymentInfo: 'Ingresa la información de pago',
      completeTheData: 'Completa los datos para realizar la compra.',
      payNow: 'Pagar ahora',
      createCode: 'Crear código de compra',
      getTickets: 'Obtener boletos',
      createOXXOCode: 'Crear código OXXO',
      getBill:
        'Para solicitar factura deberás contactar al organizador del evento directamente.',
      creditCard: 'Tarjeta de débito / crédito.',
      cardNumber: 'Número de la tarjeta',
      cardHolder: 'Titular de la tarjeta',
      cvv: 'CVV',
      payWithCard: 'Pago con tarjeta',
      payOXXO: 'Pago en OXXO',
      payCash: 'Pago en efectivo',
      asSeller:
        'Cómo vendedor podrás obtener boletos y pagarlos directamente al organizador del evento.',
      apartOxxo: 'Aparta tus lugares y paga en OXXO.',
      showOxxoReference:
        'Muestra el número de referencia en cualquier tienda OXXO para pagar tus boletos.',
      minimumPurchase:
        'Necesitas un mínimo de {{minimumPurchase}} para esta preventa',
    },
    msi: {
      short: 'MSI',
      title: 'Meses sin intereses',
      total: 'De contado {{total}}',
      paymentCash: 'De contado',
      option: '{{option}} meses de {{total}}',
      choosePaymentTerm: 'Elige un plazo a pagar',
      bank: 'Con {{bank}}',
      withoutInterest: 'Sin interés',
      getPeriod: 'Obtén hasta {{maxOption}} MSI',
      toDate: 'Hasta el {{day}} de {{month}}',
      preSale: 'PREVENTA',
      sale: 'VENTA',
      preSaleLow: 'Preventa',
      exclusivePreSale: 'Preventa exclusiva',
      details: 'Detalles',
      with: 'Con',
      payTo: 'Paga a',
      participatingCards: 'Tarjetas participantes',
      payWith: 'Paga tus boletos con {{bank}}',
      min: 'Monto mínimo',
      toValidPromo:
        'Para hacer valida está promoción, necesitas comprar un mínimo de {{minimumPurchase}}',
      paymentPlan: 'x {{paymentPlan}} meses sin intereses',
    },
    coupons: {
      invalid: 'Cupón inválido',
      add: 'Agregar cupón promocional',
      activeCoupon: 'Activa tu cupón',
      haveCoupon: 'Tengo un cupón ',
      discountAmount: '{{amount}} de descuento',
      discountPercentage: '{{percentage}}% de descuento',
      inAllTickets: 'en todos los boletos',
      inSomeTickets: 'en boletos participantes',
    },
    success: {
      title: 'Detalle de compra',
      embeddedMessage:
        'Ya puedes acceder a tus boletos para ingresar a tu eventos, gestionar tu reserva y mucho más.',
      successMessage: 'Enviaremos los boletos a:',
      successMessageWallet: 'Enviaremos la confirmación de tu compra a:',
      successMessageDisclaimer: '¿No recibiste tus boletos?',
      successMessageDisclaimerWallet:
        '¿No recibiste tu confirmación de compra?',
      successMessageOxxoDisclaimer: '¿No recibiste tu correo de confirmación?',
      disclaimer:
        'Revisa en tu carpeta de spam o verifica que tu correo sea correcto.',
      successOxxoMessage:
        'Una vez realizado el pago, enviaremos los boletos a:',
      successOxxoMessageWallet:
        'Una vez realizado el pago, enviaremos la confirmación de tu compra a: ',
      buyAgain: 'Comprar de nuevo',
      seeOtherEvents: 'Ver otros eventos',
      reservationCode: 'Código de reservación:',
      tickets_one: ' {{count}} Boleto',
      tickets_other: ' {{count}} Boletos',
      oxxoMessage: 'Corre a un OXXO y paga con tu código de referencia',
      oxxoMessage2:
        'Tienes 24 hrs para pagar, de lo contrario tus boletos se liberarán.',
      oxxoReference: 'Tu número de referencia OXXO es: ',
      oxxoExpiration: 'Vencimiento: ',
      order: 'Número de orden',
      oxxoSendEmail:
        'Te enviamos un correo de confirmación con tu número de referencia OXXO a tu correo ',
      oxxoSendEmail2:
        'una vez realizado el pago, te enviaremos de vuelta tus boletos al mismo correo.',
      oxxoSendEmailWallet2:
        'una vez realizado el pago, tus boletos estarán disponibles en la app de Boletia.',
      success: '¡Listo, los boletos ya son tuyos!',
      successWallet:
        'Abre o descarga la App Boletia para ver tus boletos usando el número',
      sendEmailMessage: 'Hemos enviado tus boletos al correo electrónico',
      footer:
        'Esta confirmación de compra no es un boleto y no te dará acceso al evento.',
      embeddedButton: 'Ver mis boletos >',
    },
    rsvp: {
      vipMessage:
        'Como asistente VIP a <strong>{{name}}</strong>. Aprovecha tu <strong>acceso a zonas exclusivas</strong> y compra tus boletos desde este link.',
      vipMessage2:
        'Como asistente VIP a <strong>{{name}}</strong>. Puedes comprar tus <strong> boletos exclusivamente a través de este link. </strong> Aprovecha tu acceso especial ahora',
      vipEvent: 'Evento exclusivo',
      vipTickets: 'Solo tú puedes acceder y comprar boletos.',
    },
    customLinks: {
      exclusiveAccess: 'Acceso Exclusivo',
      modalText:
        'Como asistente a <b> {{ name }} </b>, tienes la oportunidad de comprar <strong> hasta {{ qty }} boletos exclusivamente a través de este enlace.',
      buttonText: 'Conseguir mis boletos',
      bannerText: 'Solo tú puedes comprar hasta {{ qty }} boletos.',
    },
  },
};

export default es;
